var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M67.931,167.086c0,0-27.877,71.988,11.297,144.503 c39.174,72.516,119.879,110.802,184.469,143.548c64.59,32.746,131.661,16.799,163.534-36.838 c31.873-53.637-11.845-91.928-11.897-168.418c-0.051-76.49,11.447-96.742-29.963-161.364 c-41.41-64.623-143.059-78.925-219.9-30.996C88.631,105.45,67.931,167.086,67.931,167.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M415.334,259.882c-0.051-76.49,11.447-96.742-29.963-161.364 c-41.41-64.623-143.059-78.925-219.9-30.996c-76.841,47.929-97.54,109.565-97.54,109.565s-27.877,71.988,11.297,144.503 c35.827,66.321,106.391,104.009,167.597,135.015h156.487c9.252-7.765,17.338-17.229,23.92-28.305 C459.104,374.663,415.386,336.371,415.334,259.882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M415.334,259.882c-0.051-76.49,11.447-96.742-29.963-161.364 c-41.41-64.623-143.059-78.925-219.9-30.996c-76.841,47.929-97.54,109.565-97.54,109.565s-27.877,71.988,11.297,144.503 c35.827,66.321,106.391,104.009,167.597,135.015h156.487c9.252-7.765,17.338-17.229,23.92-28.305 C459.104,374.663,415.386,336.371,415.334,259.882z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M229.794,50.718 c1.351,5.352,0.686-4.5,3.335-16.553c2.65-12.054,7.186-7.165,7.186-7.165"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 228.962,
    y1: 38.404,
    x2: 237.267,
    y2: 34.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M244.135,30.916 c0,0-4.965,10.265,2.519,14.629"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.177,28.029 c0,0,8.194,4.552,3.061,14.407"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 245.561,
    y1: 34.394,
    x2: 251.432,
    y2: 38.681
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 250.165,
    y1: 32.505,
    x2: 245.571,
    y2: 39.818
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M71.306,292.421 c0,0-13.929-0.206-13.948,11.82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M70.155,299.99 c-0.291-1.768-6.358-3.959-7.404,0.625c-1.047,4.583,6.479,1.842,8.81-0.315c0,0-4.316,4.203-2.96,5.386"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M71.021,307.015 c0,0-1.835,2.295-3.815,1.206"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M83.19,298.954 l-10.445,10.661c0,0,5.223-5.33,8.304-3.637c3.796,2.087-1.127,7.785-5.186,3.699"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M88.472,301.857 c0,0,2.765,12.696-11.527,13.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 275.032,86.133 280.069,86.961 280.143,98.413 291.179,78.277 308.595,81.143  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 293.09,
    y1: 87.095,
    x2: 300.753,
    y2: 100.618
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 302.717,
    y1: 88.679,
    x2: 289.008,
    y2: 98.685
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M206.161,106.509 c-1.29-1.642-8.717-0.474-7.212,4.795c1.504,5.269,7.651-1.756,8.822-5.269c0,0-2.049,6.716,0,7.163"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M211.853,101.103 l-1.661,5.941c0,0,0.83-2.97,2.284-2.97c1.79,0,1.142,3.044-1.142,2.372"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 351.928,173.825 348.425,186.475 356.082,194.847  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 356.308,
    y1: 178.964,
    x2: 365.074,
    y2: 186.294
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 362.343,
    y1: 177.159,
    x2: 358.551,
    y2: 186.467
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M368.5,185.27 c0,0,0.079,2.642-1.063,2.983"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 369.615,
    y1: 176.051,
    x2: 374.898,
    y2: 179.98
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 376.864,
    y1: 172.817,
    x2: 371.642,
    y2: 191.616
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 377.117,166.292 385.598,175.892 381.985,186.391  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 143.581,414.009 155.846,377.492 170.727,394.099  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 167.084,396.771 163.942,393.177 167.288,390.277  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -70.4542 40.3781)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 66.27,
    cy: 197.287,
    rx: 12.494,
    ry: 12.494
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 80.134,
    cy: 186.352,
    r: 13.864
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 68.73,
    y1: 185.036,
    x2: 67.04,
    y2: 190.914
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 71.125,
    y1: 185.772,
    x2: 68.73,
    y2: 194.233
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 73.626,
    y1: 187.19,
    x2: 71.125,
    y2: 196.757
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.417,
    y1: 190.002,
    x2: 74.632,
    y2: 199.079
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 77.994,
    y1: 192.96,
    x2: 76.417,
    y2: 199.708
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M54.334,181.285 c-1.094-0.339-4.081,2.501-1.761,4.41c2.32,1.909,2.906-3.176,2.34-5.126c0,0,1.167,3.669,2.231,3.233"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M70.451,165.246 l3.974,7.283c0,0-1.987-3.642-0.587-5.005c1.725-1.68,3.956,1.862,1.126,3.357"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.54,
    y1: 164.383,
    x2: 149.19,
    y2: 169.729
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 149.19,
    y1: 162.986,
    x2: 144.459,
    y2: 170.053
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 154.747,
    y1: 165.015,
    x2: 160.398,
    y2: 162.914
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 163.109,
    y1: 157.021,
    x2: 166.546,
    y2: 160.063
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 169.18,
    y1: 153.364,
    x2: 164.827,
    y2: 168.303
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M416.135,150.358 l-0.232-11.416h8.628c0,0-4.781,2.634-2.586,8.781c2.195,6.147,5.746,2.634,5.746,2.634"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 401.518,345.167 411.336,338.412 424.339,339.323 425.152,355.804 415.608,362.628 403.83,361.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 403.83,361.77 413.335,354.926 425.152,355.804  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 413.335,
    y1: 354.926,
    x2: 411.336,
    y2: 338.412
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 401.518,345.167 414.493,346.669 424.339,339.323  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 414.493,
    y1: 346.669,
    x2: 415.608,
    y2: 362.628
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 403.305,221.388 402.887,243.364 422.141,234.619  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 403.305,
    y1: 221.388,
    x2: 412.479,
    y2: 238.875
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 411.009,236.072 413.243,234.994 414.739,237.981  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 235.469,
    y1: 219.307,
    x2: 243.429,
    y2: 227.838
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.493,
    y1: 218.16,
    x2: 236.803,
    y2: 227.317
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.746,213.693 c0,0,1.854-0.719,2.244,1.199c0.39,1.918-2.761,4.416-2.761,4.416h4.494"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M111.536,91.502 c0.816-10.214,6.834-18.766,15.246-23.262"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M133.654,121.985 c-7.449-1.778-13.699-6.399-17.652-12.575"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M169.299,96.114 c-1.274,15.951-15.237,27.849-31.187,26.575"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M142.723,64.926 c13.825,1.104,24.606,11.741,26.404,24.943"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M152.915,116.109 c-4.273,2.4-9.28,3.599-14.532,3.18c-14.073-1.124-24.57-13.442-23.446-27.515"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M116.561,84.609 c3.964-10.293,14.336-17.204,25.891-16.282c14.073,1.124,24.57,13.442,23.446,27.515c-0.462,5.787-2.817,10.969-6.408,14.987"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 137.908,75.413 140.417,93.808 154.562,89.413  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M360.898,129.57 c-8.342,0.079-16.182-5.093-19.107-13.401c-2.759-7.836-0.361-16.237,5.418-21.499"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M379.693,115.981 c-1.918,5.613-6.295,10.324-12.324,12.446"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M354.049,90.591 c10.448-3.678,21.9,1.81,25.578,12.258"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M370.612,94.844 c3.042,2.051,5.475,5.062,6.787,8.789c3.245,9.218-1.597,19.321-10.815,22.566c-6.913,2.434-14.325,0.319-18.967-4.78"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M344.019,115.385 c-3.245-9.218,1.597-19.321,10.815-22.566c3.457-1.217,7.038-1.297,10.335-0.435"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 353.951,98.579 360.709,109.509 354.549,117.505  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M218.969,408.429 c0-5.541,2.802-10.427,7.066-13.32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.713,419.51 c-2.93,3.082-7.07,5.003-11.659,5.003c-7.071,0-13.076-4.562-15.232-10.904"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M235.054,392.343 c8.884,0,16.085,7.202,16.085,16.085"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M235.054,422.62 c-7.838,0-14.191-6.354-14.191-14.191"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M224.003,399.525 c2.601-3.225,6.585-5.287,11.051-5.287c7.838,0,14.191,6.354,14.191,14.191c0,5.332-2.94,9.977-7.288,12.402"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 232.852,418.074 235.054,408.429 231.977,400.546  "
  }))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 47.714,
    y1: 456.95,
    x2: 452.286,
    y2: 456.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "Exam_sheets"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_28_",
    points: "252.987,246.076 246.399,371.553 162.911,367.166 163.606,353.867 169.499,241.689  222.071,244.449  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_28_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000114763258598428206100000007339890047969932419_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000114763258598428206100000007339890047969932419_)",
      fillOpacity: 0.7
    },
    points: " 226.931,319.589 208.121,321.14 213.608,344.83 163.606,353.867 169.499,241.689 222.071,244.449  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_28_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.394,
    y1: 250.273,
    x2: 197.119,
    y2: 251.414
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.175,
    y1: 254.444,
    x2: 189.948,
    y2: 255.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 179.951,
    y1: 264.568,
    x2: 242.445,
    y2: 267.851
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 179.732,
    y1: 268.739,
    x2: 242.226,
    y2: 272.022
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 179.477,
    y1: 273.605,
    x2: 232.777,
    y2: 276.405
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.374,
    y: 278.179,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 14.9795 -9.1582)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.587,
    y: 278.663,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 15.0176 -9.6409)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.799,
    y: 279.147,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 15.0502 -10.1202)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.012,
    y: 279.631,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 15.0883 -10.6027)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M176.624,264.394c-0.037,0.703-0.636,1.242-1.339,1.205c-0.702-0.037-1.242-0.636-1.205-1.339 c0.037-0.702,0.636-1.242,1.339-1.205C176.122,263.092,176.661,263.691,176.624,264.394z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 178.673,
    y1: 288.898,
    x2: 241.167,
    y2: 292.181
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 178.454,
    y1: 293.069,
    x2: 240.948,
    y2: 296.352
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 178.199,
    y1: 297.935,
    x2: 231.499,
    y2: 300.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.096,
    y: 302.509,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 16.2484 -9.0546)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.309,
    y: 302.993,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 16.2865 -9.5372)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.521,
    y: 303.477,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 16.3245 -10.0197)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.734,
    y: 303.961,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 16.3626 -10.5022)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M175.347,288.724c-0.037,0.702-0.636,1.242-1.339,1.205c-0.702-0.037-1.242-0.636-1.205-1.339 c0.037-0.702,0.636-1.242,1.339-1.205C174.844,287.422,175.384,288.021,175.347,288.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 177.395,
    y1: 313.228,
    x2: 239.889,
    y2: 316.51
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 177.176,
    y1: 317.399,
    x2: 239.67,
    y2: 320.681
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.921,
    y1: 322.265,
    x2: 230.221,
    y2: 325.065
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.818,
    y: 326.839,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 17.5294 -8.9573)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.031,
    y: 327.323,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 17.5674 -9.44)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.243,
    y: 327.807,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 17.5988 -9.9192)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.456,
    y: 328.291,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 17.6436 -10.4054)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.069,313.053c-0.037,0.702-0.636,1.242-1.339,1.205c-0.702-0.037-1.242-0.636-1.205-1.339 c0.037-0.702,0.636-1.242,1.339-1.205C173.566,311.752,174.106,312.351,174.069,313.053z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.081,
    y1: 338.253,
    x2: 238.575,
    y2: 341.536
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.862,
    y1: 342.424,
    x2: 238.356,
    y2: 345.707
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 175.606,
    y1: 347.29,
    x2: 228.907,
    y2: 350.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 175.504,
    y: 351.864,
    transform: "matrix(0.9986 0.0524 -0.0524 0.9986 18.8331 -8.8506)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.717,
    y: 352.348,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 18.8786 -9.3365)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.929,
    y: 352.832,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 18.9167 -9.8193)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.142,
    y: 353.316,
    transform: "matrix(0.9986 0.0525 -0.0525 0.9986 18.9551 -10.3021)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M172.754,338.078c-0.037,0.702-0.636,1.242-1.339,1.205c-0.702-0.037-1.242-0.636-1.205-1.339 c0.037-0.702,0.636-1.242,1.339-1.205C172.252,336.777,172.791,337.376,172.754,338.078z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 181.231,280.17 181.891,281.308 184.599,278.316  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 198.394,305.163 199.054,306.301 201.762,303.309  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 207.003,330.838 207.664,331.975 210.371,328.984  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 186.604,353.757 187.264,354.895 189.972,351.904  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    points: "197.512,336.042 116.963,358.426 83.323,237.358 116.673,228.093 163.873,214.981  194.394,324.825  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_27_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000011738218135255255680000005343799695521910206_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000011738218135255255680000005343799695521910206_)",
      fillOpacity: 0.7
    },
    points: " 194.394,324.825 132.112,328.853 116.673,228.093 163.873,214.981  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_27_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 91.637,
    y1: 243.625,
    x2: 112.597,
    y2: 237.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 92.755,
    y1: 247.649,
    x2: 107.009,
    y2: 243.688
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 100.502,
    y1: 255.73,
    x2: 160.798,
    y2: 238.975
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.62,
    y1: 259.754,
    x2: 161.916,
    y2: 242.999
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 102.925,
    y1: 264.448,
    x2: 154.35,
    y2: 250.159
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.959,
    y: 267.876,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -68.4769 38.6557)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.848,
    y: 265.406,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -67.4869 40.9418)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.736,
    y: 262.936,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -66.5012 43.2313)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.625,
    y: 260.466,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -65.5155 45.5207)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.292,256.621c0.188,0.678-0.208,1.38-0.886,1.568c-0.678,0.188-1.38-0.208-1.568-0.886 c-0.188-0.678,0.208-1.38,0.886-1.568C96.402,255.547,97.104,255.944,97.292,256.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 107.025,
    y1: 279.203,
    x2: 167.32,
    y2: 262.449
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 108.143,
    y1: 283.228,
    x2: 168.438,
    y2: 266.473
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 109.448,
    y1: 287.922,
    x2: 160.873,
    y2: 273.633
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.482,
    y: 291.35,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -74.5202 41.2565)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.371,
    y: 288.88,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -73.5378 43.5486)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.259,
    y: 286.41,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -72.5521 45.8382)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.147,
    y: 283.94,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -71.5618 48.1238)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M103.815,280.095c0.188,0.678-0.208,1.38-0.886,1.568c-0.678,0.188-1.38-0.208-1.568-0.886 c-0.188-0.678,0.209-1.38,0.886-1.568C102.925,279.021,103.627,279.418,103.815,280.095z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 113.548,
    y1: 302.678,
    x2: 173.843,
    y2: 285.923
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 114.666,
    y1: 306.702,
    x2: 174.961,
    y2: 289.947
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 115.97,
    y1: 311.397,
    x2: 167.396,
    y2: 297.107
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.005,
    y: 314.824,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -80.5703 43.8624)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.893,
    y: 312.354,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -79.5809 46.1491)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.782,
    y: 309.884,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -78.5988 48.4416)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.67,
    y: 307.414,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -77.613 50.7312)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M110.338,303.569c0.188,0.678-0.208,1.38-0.886,1.568c-0.678,0.188-1.38-0.208-1.568-0.886 s0.208-1.38,0.886-1.568C109.447,302.495,110.149,302.892,110.338,303.569z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 120.257,
    y1: 326.822,
    x2: 180.552,
    y2: 310.068
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 121.375,
    y1: 330.846,
    x2: 181.67,
    y2: 314.092
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 122.679,
    y1: 335.541,
    x2: 174.105,
    y2: 321.252
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.714,
    y: 338.969,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -86.7857 46.5372)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.602,
    y: 336.499,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -85.8001 48.8267)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.491,
    y: 334.029,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -84.8144 51.1162)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.379,
    y: 331.559,
    transform: "matrix(0.9635 -0.2677 0.2677 0.9635 -83.8287 53.4056)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M117.047,327.714c0.188,0.678-0.209,1.38-0.886,1.568c-0.678,0.188-1.38-0.208-1.568-0.886 s0.208-1.38,0.886-1.568C116.157,326.64,116.859,327.036,117.047,327.714z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 115.044,267.777 116.032,268.646 117.648,264.949  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 112.63,293.97 113.618,294.839 115.234,291.142  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 119.147,317.201 120.135,318.07 121.752,314.372  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 143.622,336.231 144.61,337.1 146.226,333.403  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.974,
    y: 190.74,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -23.4663 17.3943)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 83.601,
    height: 125.65
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 129.253,
    y1: 202.641,
    x2: 150.908,
    y2: 200.561
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 129.652,
    y1: 206.799,
    x2: 144.378,
    y2: 205.384
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 135.872,
    y1: 216.107,
    x2: 198.165,
    y2: 210.123
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 136.271,
    y1: 220.264,
    x2: 198.564,
    y2: 214.281
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 136.737,
    y1: 225.115,
    x2: 189.867,
    y2: 220.011
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.659,
    y: 229.249,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -21.5245 14.4706)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.842,
    y: 228.367,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -21.3938 15.3414)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.025,
    y: 227.485,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -21.2674 16.2153)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.208,
    y: 226.603,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -21.141 17.0893)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.556,216.425c0.067,0.7-0.446,1.322-1.146,1.39c-0.7,0.067-1.322-0.446-1.389-1.146 c-0.067-0.7,0.446-1.322,1.146-1.389C131.866,215.212,132.488,215.725,132.556,216.425z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.201,
    y1: 240.359,
    x2: 200.494,
    y2: 234.375
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.6,
    y1: 244.516,
    x2: 200.894,
    y2: 238.533
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 139.066,
    y1: 249.367,
    x2: 192.196,
    y2: 244.263
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.989,
    y: 253.501,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -23.8279 14.8009)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.172,
    y: 252.619,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -23.7019 15.6752)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.355,
    y: 251.737,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -23.5709 16.5456)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.538,
    y: 250.855,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -23.4538 17.4269)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M134.885,240.677c0.067,0.7-0.446,1.322-1.146,1.39c-0.7,0.067-1.322-0.446-1.39-1.146 c-0.067-0.7,0.446-1.322,1.146-1.39C134.196,239.464,134.818,239.977,134.885,240.677z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 140.531,
    y1: 264.611,
    x2: 202.824,
    y2: 258.627
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 140.93,
    y1: 268.768,
    x2: 203.223,
    y2: 262.784
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 141.396,
    y1: 273.618,
    x2: 194.525,
    y2: 268.515
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.318,
    y: 277.753,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -26.1369 15.1354)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.501,
    y: 276.871,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -26.0152 16.0126)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.094,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.684,
    y: 275.989,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -25.8785 16.8793)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.867,
    y: 275.107,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -25.7572 17.757)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.215,264.929c0.067,0.7-0.446,1.322-1.146,1.39c-0.7,0.067-1.322-0.446-1.39-1.146 c-0.067-0.7,0.446-1.322,1.146-1.39C136.525,263.716,137.147,264.229,137.215,264.929z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 142.927,
    y1: 289.555,
    x2: 205.22,
    y2: 283.572
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.326,
    y1: 293.713,
    x2: 205.619,
    y2: 287.729
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.792,
    y1: 298.563,
    x2: 196.921,
    y2: 293.46
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144.714,
    y: 302.698,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -28.5105 15.4784)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.094
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.897,
    y: 301.816,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -28.3841 16.3524)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.08,
    y: 300.934,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -28.2577 17.2264)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.263,
    y: 300.052,
    transform: "matrix(0.9954 -0.0956 0.0956 0.9954 -28.1252 18.096)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 5.095,
    height: 5.095
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.611,289.874c0.067,0.7-0.446,1.322-1.146,1.389c-0.7,0.067-1.322-0.446-1.39-1.146 c-0.067-0.7,0.446-1.322,1.146-1.39C138.921,288.66,139.543,289.174,139.611,289.874z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 139.441,231.348 140.262,232.376 142.499,229.018  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 160.107,253.532 160.929,254.56 163.165,251.202  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 153.303,279.172 154.124,280.2 156.36,276.841  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 173.931,302.162 174.752,303.189 176.988,299.831  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M307.147,137.712 h-51.662c-3.8,0-6.88,3.081-6.88,6.88v44.376c0,3.8,3.081,6.881,6.88,6.881h22.899l13.117,15.816l-3.288-15.816h18.934 c3.8,0,6.88-3.081,6.88-6.881v-44.376C314.027,140.792,310.947,137.712,307.147,137.712z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M285.447,162.074v-4.7l-3.521-0.303c-0.21-0.743-0.501-1.45-0.871-2.11l2.273-2.701l-3.323-3.323 l-2.701,2.273c-0.66-0.37-1.367-0.661-2.11-0.871l-0.303-3.521h-4.7l-0.303,3.521c-0.743,0.21-1.45,0.501-2.11,0.871 l-2.701-2.273l-3.323,3.323l2.273,2.701c-0.37,0.66-0.661,1.367-0.87,2.11l-3.521,0.303v4.7l3.521,0.303 c0.21,0.743,0.501,1.45,0.87,2.11l-2.273,2.701l3.323,3.323l2.701-2.273c0.66,0.37,1.367,0.661,2.11,0.87l0.303,3.521h4.7 l0.303-3.521c0.743-0.21,1.45-0.501,2.11-0.87l2.701,2.273l3.323-3.323l-2.273-2.701c0.37-0.66,0.661-1.367,0.871-2.11 L285.447,162.074z M272.54,165.185c-3.016,0-5.461-2.445-5.461-5.462c0-3.016,2.445-5.462,5.461-5.462s5.462,2.445,5.462,5.462 C278.002,162.74,275.557,165.185,272.54,165.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M300.998,172.565v-3.344l-2.505-0.216c-0.149-0.529-0.356-1.032-0.62-1.501l1.617-1.922 l-2.365-2.365l-1.922,1.617c-0.469-0.263-0.973-0.47-1.501-0.62l-0.216-2.505h-3.344l-0.216,2.505 c-0.529,0.149-1.032,0.356-1.501,0.62l-1.922-1.617l-2.365,2.365l1.617,1.922c-0.263,0.469-0.47,0.973-0.619,1.501l-2.505,0.216 v3.344l2.505,0.216c0.149,0.529,0.356,1.032,0.619,1.501l-1.617,1.922l2.365,2.365l1.922-1.617 c0.469,0.263,0.973,0.47,1.501,0.619l0.216,2.505h3.344l0.216-2.505c0.529-0.149,1.032-0.356,1.501-0.619l1.922,1.617 l2.365-2.365l-1.617-1.922c0.263-0.469,0.47-0.973,0.62-1.501L300.998,172.565z M291.814,174.779 c-2.146,0-3.886-1.74-3.886-3.886c0-2.146,1.74-3.886,3.886-3.886c2.146,0,3.886,1.74,3.886,3.886 C295.7,173.039,293.96,174.779,291.814,174.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M284.637,180.355v-2.38l-1.783-0.154c-0.106-0.376-0.254-0.734-0.441-1.068l1.151-1.368 l-1.683-1.683l-1.368,1.151c-0.334-0.187-0.692-0.335-1.068-0.441l-0.154-1.783h-2.38l-0.154,1.783 c-0.376,0.106-0.734,0.254-1.068,0.441l-1.368-1.151l-1.683,1.683l1.151,1.368c-0.187,0.334-0.335,0.692-0.441,1.068 l-1.783,0.154v2.38l1.783,0.154c0.106,0.376,0.254,0.734,0.441,1.068l-1.151,1.368l1.683,1.683l1.368-1.151 c0.334,0.187,0.692,0.335,1.068,0.441l0.154,1.783h2.38l0.154-1.783c0.376-0.106,0.734-0.253,1.068-0.441l1.368,1.151 l1.683-1.683l-1.151-1.368c0.187-0.334,0.335-0.692,0.441-1.068L284.637,180.355z M278.102,181.93 c-1.527,0-2.765-1.238-2.765-2.765s1.238-2.765,2.765-2.765c1.527,0,2.765,1.238,2.765,2.765S279.63,181.93,278.102,181.93z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 279.934,308.367 320.21,456.95 326.234,456.95 285.958,308.367  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.297,
    y: 414.828,
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 76.352,
    height: 6.216
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M411.377,274.99l-49.323,181.96h-6.024l49.323-181.96c1.819-6.711-2.352-12.166-9.304-12.166h-42.502 c-6.939,0-14.08,5.455-15.899,12.166l-49.323,181.96h-6.023l49.323-181.96c2.692-9.933,13.21-17.981,23.499-17.981h42.502 C407.914,257.009,414.069,265.058,411.377,274.99z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    d: "M412.16,275.05l-12.24,45.18c-1.01,3.73-4.96,6.75-8.82,6.75h-69.84c-3.86,0-6.17-3.02-5.16-6.75 l12.25-45.18c1.01-3.72,4.96-6.75,8.82-6.75H407C410.86,268.3,413.17,271.33,412.16,275.05z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_26_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000044156845950979701770000007476569611599380155_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_26_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000044156845950979701770000007476569611599380155_)",
      fillOpacity: 0.7
    },
    d: " M412.16,275.05l-12.24,45.18c-1.01,3.73-4.96,6.75-8.82,6.75h-69.84c-3.86,0-6.17-3.02-5.16-6.75l12.25-45.18 c1.01-3.72,4.96-6.75,8.82-6.75h36.11c15.61,16.03,13.62,45.49,12.6,54.39c3.2-0.76,6.12-3.39,6.97-6.52l12.25-45.18 c0.26-0.96,0.3-1.87,0.15-2.69H407C410.86,268.3,413.17,271.33,412.16,275.05z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_26_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 371.103,372.707 393.939,456.95 399.962,456.95 377.127,372.707  "
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    d: "M377.15,363.04v8.24h-89.92v-8.24c0-3.35,2.71-6.06,6.06-6.06h77.79c2.8,0,5.16,1.89,5.86,4.47 C377.08,361.95,377.15,362.49,377.15,363.04z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_25_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000002365782272489664480000012265880583883672708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000002365782272489664480000012265880583883672708_)",
      fillOpacity: 0.7
    },
    d: " M376.94,361.45c-2.91,3.42-8.13,6.9-17.11,9.83h-72.6v-8.24c0-3.35,2.71-6.06,6.06-6.06h77.79 C373.88,356.98,376.24,358.87,376.94,361.45z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_25_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M380.205,376.486h-95.247c-0.942,0-1.706-0.764-1.706-1.706v-4.319c0-0.942,0.764-1.706,1.706-1.706h95.247 c0.942,0,1.706,0.764,1.706,1.706v4.319C381.911,375.722,381.147,376.486,380.205,376.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    d: "M284.31,369.04c-4.31,4.39,16.58,73.37,16.58,73.37c-2.28,1.98-5.64,2.92-8.82,3.34 c-4.6,0.61-8.81,0.13-8.81,0.13s-29.94-72.62-21.7-90.64c8.24-18.02,59.37-26.27,59.37-26.27l2.18-5.4l26.45-3.72l4.37,32.39 c0,0-4.34,0.42-10.87,1.26C325.55,355.75,292.23,360.98,284.31,369.04z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_24_",
    style: {
      overflow: "visible",
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000157986952232357630020000018217477566885559183_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_24_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_00000157986952232357630020000018217477566885559183_)"
    },
    d: "M300.89,442.41 c-2.28,1.98-5.64,2.92-8.82,3.34c-5.81-21.6-20.6-79.24-14.99-86.29c6.91-8.7,41.11-16.61,41.11-16.61 c0.14-4.44,12.13-8.44,12.13-8.44l12.74,19.09c-17.51,2.25-50.83,7.48-58.75,15.54C280,373.43,300.89,442.41,300.89,442.41z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_24_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    d: "M269.515,303.714c-4.394-0.758,26.859-28.154,26.859-28.154l15.066,10.143 c0,0-25.643,18.056-29.67,18.551C277.742,304.749,269.515,303.714,269.515,303.714z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_23_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000136400883796629826460000000586451592559109020_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000136400883796629826460000000586451592559109020_)",
      fillOpacity: 0.7
    },
    d: " M269.515,303.714c-4.394-0.758,26.859-28.154,26.859-28.154l15.066,10.143c0,0-25.643,18.056-29.67,18.551 C277.742,304.749,269.515,303.714,269.515,303.714z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_23_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M275.024,292.188c0,0,6.551,1.629,8.552,3.027s1.437,6.326,1.437,6.326S276.262,299.046,275.024,292.188z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "270.821,279.645 282.997,302.998 284.44,302.998 272.874,278.492  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M281.8,296.529 c0,0-7.68-5.461-9.557-5.461c-1.877,0-7.509,6.653-7.509,9.982c0,3.329,12.273,5.181,14.677,2.348 c1.195-1.408-1.18-4.807-1.18-4.807s3.569,3.698,4.593,4.252c1.024,0.555,2.901-0.171,2.901-0.171 S283.165,298.591,281.8,296.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M278.231,304.188 c0,0-2.916-3.791-6.415-5.597"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M278.231,298.591 c0,0-2.66-2.318-4.452-2.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M269.86,301.542 c0,0,4.303,2.262,5.37,3.223"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.165,263.579c-3.937,2.746-21.583,20.891-21.583,20.891s8.27,9.405,15.517,10.772l19.648-9.538L306.165,263.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.165,263.579c-3.937,2.746-21.583,20.891-21.583,20.891s8.27,9.405,15.517,10.772l19.648-9.538L306.165,263.579z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    d: "M296.67,435.088l8.308,21.862c0,0,1.385,5.632-23.736,3.852l-13.846-1.187L296.67,435.088z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_22_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000077325880776183879440000018188198398010532763_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_00000077325880776183879440000018188198398010532763_)"
    },
    d: "M296.67,435.088 l8.308,21.862c0,0,1.385,5.632-23.736,3.852l-13.846-1.187L296.67,435.088z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_22_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.505,445.571c0,0,1.78,8.505,0,14.835c0,0-26.505,4.154-32.44,2.571c-5.934-1.582-9.528-4.539-9.709-6.028 c0,0,0.215-4.06,6.149-5.247c5.934-1.187,17.759-1.978,22.429-8.703C284.604,436.275,293.505,445.571,293.505,445.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M328.49,322.724 c8.472-12.082,47.406,2.458,47.406,2.458s3.716,29.08-11.794,36.835c-15.509,7.755-37.87,7.342-43.91,13.632l-24.582,72.583 c0,0-8.827,3.693-21.671-2.123c0,0,15.609-54.813,20.188-74.272c4.531-19.255,33.866-32.331,33.866-32.331 s-2.468-2.793-3.378-6.078"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M367.915,350.52 c-1.246,1.105-2.56,2.133-3.929,3.083"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M371.103,325.892 c3.175,6.896,3.425,15.662-1.028,22.048"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M362.232,326.98 c0,0-0.815,5.316,1.559,7.426c2.374,2.11,9.641,3.188,9.641,3.188"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M330.306,327.237 c0,0,0.333,5.305-1.816,5.05c-2.15-0.254-2.257,2.119-2.257,2.119"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.678,267.655c-0.325-1.408-0.513-2.782-0.513-4.076c0,0,12.028-10.117,27.446-10.064c18.398,0.063,29.646,5.85,34.154,13.89 c7.134,12.723,8.132,57.777,8.132,57.777s-46.165,7.121-52.79-1.616c-1.148-1.514-0.268-12.251-0.268-12.251 s-5.169-13.555-6.26-24.074c0,0-1.989-2.678-4.229-6.498c-1.477-2.52-3.064-5.536-4.26-8.609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.678,267.655c-0.325-1.408-0.513-2.782-0.513-4.076c0,0,12.028-10.117,27.446-10.064c18.398,0.063,29.646,5.85,34.154,13.89 c7.134,12.723,8.132,57.777,8.132,57.777s-46.165,7.121-52.79-1.616c-1.148-1.514-0.268-12.251-0.268-12.251 s-5.169-13.555-6.26-24.074c0,0-1.989-2.678-4.229-6.498c-1.477-2.52-3.064-5.536-4.26-8.609"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M324.361,278.492 c0,0,7.05,27.352,5.964,33.365c-0.537,2.977,1.027,6.068,1.027,6.068s-3.218,3.167-1.027,7.383"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M343.064,301.116 c-1.376-0.116-2.637-0.444-3.542-1.116l-2.091-9.16c0,0,6.447,0.709,12.381-0.866L352.055,300c0,0-1.662,0.485-3.838,0.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.352,282.047c0,0-5.958-25.56,9.138-28.532c15.095-2.972,18.251,4.104,17.357,8.898 c-1.19,6.386-13.734,22.057-13.734,22.057l-7.753-5.978L319.352,282.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.352,282.047c0,0-5.958-25.56,9.138-28.532c15.095-2.972,18.251,4.104,17.357,8.898 c-1.19,6.386-13.734,22.057-13.734,22.057l-7.753-5.978L319.352,282.047z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M299.494,360.954 c0,0,9.774-11.294,31.857-19.822c0,0-5.723-1.754-6.991-4.128"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 287.993,
    y1: 395.553,
    x2: 279.045,
    y2: 428.009
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M357.066,301.998c0,0,4.024,6.756,20.474,6.132c0,0-4.518-5.149-11.243-6.975C359.571,299.33,357.066,301.998,357.066,301.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.167,304.714c0,0,3.821-5.923,7.327-7.11c3.506-1.187,13.78-1.29,15.363-1.332c1.583-0.042,29.847,7.138,43.099,11.554 l-1.154-22.123l17.816,1.403c0,0-0.719,27.01-3.488,34.155c-2.769,7.145-6.737,5.409-13.51,2.491 c-26.633-11.474-42.235-19.466-43.68-19.038C313.495,305.143,293.167,304.714,293.167,304.714z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M353.354,272.843c-0.466,1.933-0.639,3.886-0.441,5.617c0.791,6.923,4.154,23.539,4.154,23.539s16.617,2.374,20.474,6.132 c0,0,2.735-22.026-2.836-33.167c-5.571-11.141-11.353-12.404-11.353-12.404c-3.648-0.903-6.958,2.503-8.853,6.867"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M353.354,272.843c-0.466,1.933-0.639,3.886-0.441,5.617c0.791,6.923,4.154,23.539,4.154,23.539s16.617,2.374,20.474,6.132 c0,0,2.735-22.026-2.836-33.167c-5.571-11.141-11.353-12.404-11.353-12.404c-3.648-0.903-6.958,2.503-8.853,6.867"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M304.549,281.396 c0,0,3.262,2.945,8.505,4.308"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M357.066,281.396 c0,0,6.036,11.34,13.582,13.846"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M318.193,368.755 c0,0,1.108,0.838,1.554,3.866"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M314.077,372.621 c0,0,3.061,0.189,4.893,2.823"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M281.01,360.954 c0,0,3.204,1.618,2.509,6.206"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M277.631,364.897 c0,0,4.371,2.59,4.683,4.918"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M328.279,336.916 c0,0,9.732,1.367,11.908,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "M324.36,277.39c0,0-1.24-2.95-1.02-7.43c0.04-0.81,0.12-1.66,0.27-2.55l-1.69-2.68l-2.17-3.45 l2.51-10.05c0,0,15.98,3.08,17.2,7.54C340.67,263.25,324.36,277.39,324.36,277.39z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_21_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000157995846162275030600000002629899610607640253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000157995846162275030600000002629899610607640253_)",
      fillOpacity: 0.7
    },
    d: " M323.34,269.96c0.04-0.81,0.12-1.66,0.27-2.55l-1.69-2.68c2.77-0.55,5.8-1.78,7.81-4.38 C329.73,260.35,330.26,267.28,323.34,269.96z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_21_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M334.404,252.121c4.946-13.039,1.679-35.131-22.327-30.889c-14.131,2.497-15.775,19.52-11.056,27.074 c4.719,7.553-0.295,7.802,6.784,13.406c2.862,2.266,5.18,6.123,8.598,6.365c4.065,0.287,9.281-3.567,13.167-7.722"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M310.754,248.306 c0,0,3.539-3.212,7.742-1.885"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M304.117,248.306 c0,0-1.204-2.546-4.584-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.456,252.946c0,0-0.505,2.596-1.174,5.217c-0.649,2.544,4.195,1.189,3.978,0.783"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M311.789,262.273 c0,0,3.103-0.742,5.267-3.454"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M315.676,251.6c0.198,0.727-0.101,1.442-0.669,1.596c-0.568,0.155-1.189-0.309-1.387-1.036 c-0.198-0.727,0.101-1.442,0.669-1.596C314.856,250.409,315.477,250.873,315.676,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M304.974,251.376c0.198,0.727,0.052,1.4-0.327,1.503c-0.379,0.103-0.846-0.402-1.045-1.129 c-0.198-0.727-0.052-1.4,0.327-1.503S304.775,250.649,304.974,251.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.602,234.918c0,0-3.724,9.733-12.923,9.512c0,0,3.19-2.43,4.074-4.754c0,0-7.079,7.01-14.158,3.449 c-7.079-3.561-3.638-20.105,7.251-26.662c10.889-6.557,21.949-4.791,25.71,1.455c0,0,7.605-0.699,10.95,10.474 c2.986,9.975-1.792,25.153-6.49,25.329c-7.268,0.272-8.731-7.621-8.731-7.621S320.929,242.218,319.602,234.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M327.566,252.172c0,0-0.221-9.18,4.977-8.074c5.199,1.106,1.437,11.724-2.489,11.614"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M311.425,309.78 h-80.636c-0.899,0-1.629-0.729-1.629-1.629v-2.808c0-0.9,0.729-1.629,1.629-1.629h80.636c0.9,0,1.629,0.729,1.629,1.629v2.808 C313.054,309.051,312.325,309.78,311.425,309.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 111.792,425.863 77.782,425.863 81.344,456.95 108.229,456.95  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M115.82,404.217 c0,0-14.853,1.172-15.473,12.131C100.347,416.348,115.388,423.273,115.82,404.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M86.437,406.938 c0,0-8.298-11.219-21.706-5.466C64.73,401.472,72.919,415.036,86.437,406.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M65.867,371.517 c0,0-2.386,21.584,17.26,15.64C83.127,387.157,76.888,371.289,65.867,371.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M89.989,359.502 c0,0-15.537,8.379-4.113,21.093C85.876,380.595,96.773,371.514,89.989,359.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M109.107,378.789c0,0-16.893-1.704-16.893,13.934C92.213,392.722,109.107,393.388,109.107,378.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M93.176,438.67 c0,0,7.702-16.163,0.309-32.625c-7.393-16.462-9.893-30.324-6.03-40.096"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M103.557,382.993 c0,0-10.126,4.023-13.568,14.454"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M71.207,380.152 c0,0,5.852,7.971,15.766,7.11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M71.207,403.765 c0,0,16.207,4.669,22.647,3.141"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M110.976,409.152 c0,0-7.244,7.951-14.53,7.827"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 76.321,
    y: 425.176,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 189.5739 854.7379)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 36.933,
    height: 4.385
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bag"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M381.241,396.971c0,0-12.391,7.315-21.195,22.017c-8.804,14.702-15.784,35.381-4.943,37.961 l10.305-0.389l19.841-6.815l-2.079-4.026c0,0-17.375,9.207-20.345,9.207c-2.97,0-6.831,0.743-8.465-0.445 c-1.634-1.188,5.713-27.919,21.42-36.83C391.488,408.742,381.241,396.971,381.241,396.971z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_20_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000011725933100578330550000017251672000463026597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_20_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#XMLID_00000011725933100578330550000017251672000463026597_)",
      fillOpacity: 0.7
    },
    d: " M381.241,396.971c0,0-12.391,7.315-21.195,22.017c-8.804,14.702-15.784,35.381-4.943,37.961l10.305-0.389l19.841-6.815 l-2.079-4.026c0,0-17.375,9.207-20.345,9.207c-2.97,0-6.831,0.743-8.465-0.445c-1.634-1.188,5.713-27.919,21.42-36.83 C391.488,408.742,381.241,396.971,381.241,396.971z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_20_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M392.527,387.357 c0,0,0-4.307,6.534-4.901c6.534-0.594,7.456,5.703,7.456,5.703h-2.25c0,0,0.055-3.77-4.745-4.06c-4.8-0.29-4.619,4.06-4.619,4.06 L392.527,387.357z"
  }), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "M382.874,456.95c-13.811,0-11.19-61.935-9.605-65.022c1.585-3.087,41.656-4.602,45.606-3.303 c3.95,1.299,19.792,63.034,11.053,67.935L382.874,456.95z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_19_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000161615052531639157960000003675992644821394599_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000161615052531639157960000003675992644821394599_)",
      fillOpacity: 0.7
    },
    d: " M382.874,456.95c-13.811,0-11.19-61.935-9.605-65.022c1.585-3.087,41.656-4.602,45.606-3.303 c3.95,1.299,19.792,63.034,11.053,67.935L382.874,456.95z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_19_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M373.27,391.928 c5.001,1.071,7.879,21.341,14.608,26.502c6.729,5.161,38.464,4.046,42.051,0c3.587-4.046-3.426-26.796-8.533-30.272 c-5.107-3.476-8.726-0.098-23.073-1.694C377.047,384.099,373.27,391.928,373.27,391.928z"
  }), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M409.687,403.581l5.879,4.803c0.349,0.285,0.385,0.805,0.079,1.136l-4.571,4.939 c-0.296,0.319-0.795,0.336-1.111,0.036l-5.837-5.535c-0.327-0.31-0.325-0.833,0.006-1.139l4.53-4.208 C408.947,403.348,409.385,403.334,409.687,403.581z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_18_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000092443477807408197700000000581875593590395295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#XMLID_00000092443477807408197700000000581875593590395295_)",
      fillOpacity: 0.7
    },
    d: " M409.687,403.581l5.879,4.803c0.349,0.285,0.385,0.805,0.079,1.136l-4.571,4.939c-0.296,0.319-0.795,0.336-1.111,0.036 l-5.837-5.535c-0.327-0.31-0.325-0.833,0.006-1.139l4.53-4.208C408.947,403.348,409.385,403.334,409.687,403.581z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_18_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M390.3,428.79c0,0,26.577,2.187,39.628-1.188c0,0,2.547,1.782,3.736,5.346 c1.188,3.564,3.667,15.742-3.736,18.86c-7.402,3.119-33.985,2.525-37.549-1.04C388.815,447.205,390.3,428.79,390.3,428.79z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_17_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000112623455522281431660000018359053039994482336_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#XMLID_00000112623455522281431660000018359053039994482336_)",
      fillOpacity: 0.7
    },
    d: " M390.3,428.79c0,0,26.577,2.187,39.628-1.188c0,0,2.547,1.782,3.736,5.346c1.188,3.564,3.667,15.742-3.736,18.86 c-7.402,3.119-33.985,2.525-37.549-1.04C388.815,447.205,390.3,428.79,390.3,428.79z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_17_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M390.3,428.79 c0,0,3.119,8.414,4.752,9.702c1.634,1.288,36.157,1.288,39.983-1.831c3.826-3.119-1.417-8.762-5.107-9.059 C429.928,427.602,405.744,430.424,390.3,428.79z"
  }), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M379.162,427.008c0,0,0.891,17.672,2.673,21.682c0,0-4.062,2.376-8.565,0 c-4.503-2.376-3.761-17.601-2.87-17.562C371.291,431.166,379.162,427.008,379.162,427.008z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible",
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000050639285161935127280000013414644869539745411_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#XMLID_00000050639285161935127280000013414644869539745411_)",
      fillOpacity: 0.7
    },
    d: " M379.162,427.008c0,0,0.891,17.672,2.673,21.682c0,0-4.062,2.376-8.565,0c-4.503-2.376-3.761-17.601-2.87-17.562 C371.291,431.166,379.162,427.008,379.162,427.008z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_16_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M379.162,427.008 l-6.691,1.337c0,0-6.378,4.9-3.556,6.534C371.736,436.512,379.013,432.503,379.162,427.008z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrant);
export default __webpack_public_path__ + "static/media/grant.9d9aef29ce41a2533bf5c0ccd47c5079.svg";
export { ForwardRef as ReactComponent };